<template>
    <div>
        <!-- 页面导航栏 -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-document"></i> 金料定价方案管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 主容器 -->
        <div class="container" v-if=!DtlTableVisible>
            <!-- 搜索区域 -->
            <div class="handle-box">
                <el-input v-model="name" placeholder="请输入方案编号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float:right" type="primary" v-if="perData.allow_add == 1" @click="handleAdd">{{ $t('common.add') }}
                </el-button>
            </div>
            <!-- 数据表格 -->
            <el-table :data="tableData" border stripe class="table" ref="multipleTable"
                      header-cell-class-name="table-header">
                <!-- 表格列定义 -->
                <el-table-column type="index" label="序号" width="90" align="center"></el-table-column>
                <el-table-column prop="metalpricingplan_no" label="方案编号" align="center"></el-table-column>
                <el-table-column prop="metalpricingplan_name" label="方案名称" align="center"></el-table-column>
                <el-table-column prop="check" label="审核" align="center" width="100">
                    <template slot-scope="scope">
                        <el-tag
                            :type="getCheckTagType(scope.row.check)"
                            size="mini"
                        >
                            {{ getCheckName(scope.row.check) }}
                        </el-tag>
                    </template>
                </el-table-column>


                <el-table-column v-if="systemSet.isstores == 1" prop="store_no" label="所属门店编号"
                                 align="center"></el-table-column>
                <el-table-column v-if="systemSet.isstores == 1" prop="store_name" label="所属门店名称"
                                 align="center"></el-table-column>
                <!-- 启用状态列 -->
                <el-table-column label="启用" align="center" width="100">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                                   @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column prop="remark" :label="$t('common.remark')" align="center"></el-table-column>
                <el-table-column prop="build_name" :label="$t('common.creator')" align="center"></el-table-column>
                <el-table-column prop="build_date" :label="$t('common.createTime')" align="center"></el-table-column>
                <el-table-column prop="modify_name" label="最后修改人" align="center"></el-table-column>
                <el-table-column prop="modify_date" label="最后修改时间" align="center"></el-table-column>
                <el-table-column prop="check_name" :label="$t('common.auditor')" align="center"></el-table-column>
                <el-table-column prop="check_date" :label="$t('common.auditTime')" align="center"></el-table-column>

                <!-- 操作列（仅允许编辑时显示） -->
                <el-table-column label="操作" align="center" width="400">
                    <template slot-scope="scope">
                        <el-button size="mini" type="success" @click="showDtl(scope.row)">方案内容</el-button>
                        <el-button size="mini" type="warning" @click="handleCheck(scope.row,1)"
                                   v-if="perData.allow_check == 1 && scope.row.check == 0">{{ $t('common.audit') }}
                        </el-button>
                        <el-button size="mini" type="info" @click="handleCheck(scope.row,0)"
                                   v-if="perData.allow_checkoff == 1 && scope.row.check == 1">反审
                        </el-button>
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
                                   v-if="perData.allow_edit == 1">{{ $t('common.edit') }}
                        </el-button>
                        <el-button type="danger" plain @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1">
                            {{ $t('common.delete') }}
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 30]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 子容器 -->
        <div class="container" v-if=DtlTableVisible>
            <div>方案:{{ MetalPricingPlanNo }}—{{ MetalPricingPlanName }}</div>
            <div class="handle-box" style="float:right" >
                    <el-button  type="primary" v-if="perData.allow_add == 1" @click="handleDtlAdd">{{ $t('common.add') }} </el-button>
                    <el-button  type="info" @click="closeDtl">{{ $t('common.back') }}</el-button>
            </div>
            <!-- 数据表格 -->
            <el-table :data="DtltableData" border stripe class="table" ref="multipleTable"
                      header-cell-class-name="table-header">
                <!-- 表格列定义 -->
                <el-table-column type="index" label="序号" width="90" align="center"></el-table-column>
                <el-table-column prop="pricingtype_no" label="定价类型编号" align="center"></el-table-column>
                <el-table-column prop="pricingtype_name" label="定价类型名称" align="center"></el-table-column>
                <el-table-column prop="style_no" label="产品编号" align="center"></el-table-column>
                <el-table-column prop="style_name" label="产品名称" align="center"></el-table-column>

                <el-table-column prop="margin_prc" label="保证金单价(元/克)" align="center"></el-table-column>
                <el-table-column prop="swapfree_days" label="免息天数" align="center"></el-table-column>
                <el-table-column prop="swap_rate" label="仓息率" align="center"></el-table-column>
                <el-table-column prop="remark" :label="$t('common.remark')" align="center"></el-table-column>

                <!-- 操作列（仅允许编辑时显示） -->
                <el-table-column label="操作" align="center" width="400">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleDtlEdit(scope.row)"
                                   v-if="perData.allow_edit == 1">{{ $t('common.edit') }}
                        </el-button>
                        <el-button type="danger" plain @click="handleDtlDelete(scope.row)"
                                   v-if="perData.allow_dele == 1">{{ $t('common.delete') }}
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="dtlPageIndex"
                    :page-sizes="[10, 20, 30]"
                    :page-size="dtlPageSize"
                    :total="dtlPageTotal"
                    @current-change="handleDtlPageChange"
                    @size-change="pageDtlSizeChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 新增编辑对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-form ref="form" :model="addEditForm" label-width="120px">
                <!-- 表单字段 -->
                <el-form-item label="方案编号">
                    <el-input v-model="addEditForm.metalpricingplan_no" :disabled="!isAdd"></el-input>
                </el-form-item>
                <el-form-item label="方案名称">
                    <el-input v-model="addEditForm.metalpricingplan_name"></el-input>
                </el-form-item>
                <el-form-item label="所属门店" prop="store_no" v-if="systemSet.isstores == 1">
                    <el-select
                        v-model="addEditForm.store_no"
                        clearable
                        filterable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in pullData.store"
                            :key="index"
                            :label="item.store_name"
                            :value="item.store_no"
                        >
                            <span style="margin-left: 10px">{{ item.store_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input v-model="addEditForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="saveData">确 定</el-button>
    </span>
        </el-dialog>

        <!-- 明细新增编辑对话框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogDtlVisible" width="30%" :before-close="handleDtlClose">

            <el-form ref="form" :model="addEditDtlForm" label-width="120px">
                <!-- 表单字段 -->
                <el-form-item label="定价类型" prop="pricingtype_no">
                    <el-select
                        v-model="addEditDtlForm.pricingtype_no"
                        clearable
                        filterable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in pullData.pricingtype"
                            :key="index"
                            :label="item.pricingtype_name"
                            :value="item.pricingtype_no"
                        >
                            <span style="margin-left: 10px">{{ item.pricingtype_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.pricingtype_no }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品" prop="style_no">
                    <el-select
                        v-model="addEditDtlForm.style_no"
                        clearable
                        filterable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in pullData.style"
                            :key="index"
                            :label="item.style_name"
                            :value="item.style_no"
                        >
                            <span style="margin-left: 10px">{{ item.style_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.style_no }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="保证金单价">
                    <el-input-number v-model="addEditDtlForm.margin_prc" :controls=false
                                     :precision="4"></el-input-number>
                    <span style="margin-left: 10px;">元/克</span>
                </el-form-item>
                <el-form-item label="免息天数">
                    <el-input-number v-model="addEditDtlForm.swapfree_days" :controls=false
                                     :precision="4"></el-input-number>
                </el-form-item>
                <el-form-item label="仓息率">
                    <el-input-number v-model="addEditDtlForm.swap_rate" :controls=false
                                     :precision="4"></el-input-number>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input v-model="addEditDtlForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
        <el-button @click="handleDtlClose">取 消</el-button>
        <el-button type="primary" @click="saveDtlData">确 定</el-button>
    </span>
        </el-dialog>

    </div>
</template>

<script>
// 导入 API 接口
import {
    apiCurrentPermisson,
    apiGetMetalPricingPlanStatusList,
    apiMetalPricingPlanPull,
    apiAddMetalPricingPlanData,
    apiUpdateMetalPricingPlanStatus,
    apiUpdateMetalPricingPlanData,
    apiDeleteMetalPricingPlanData,
    apiCheckMetalPricingPlanData,
    apiGetMetalPricingPlanDtlDate,
    apiAddDtlMetalPricingPlanData,
    apiUpdateDtlMetalPricingPlanData,
    apiDeleteDtlMetalPricingPlanData
} from '@/request/api';

export default {
    name: 'basetable',
    data() {
        return {
            addEditForm: {},
            addEditDtlForm: {},
            DtlTableVisible: false,
            isAdd: true,
            dialogVisible: false,
            dialogDtlVisible: false,
            pullData: [],
            name: '',
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            dtlSeek: '',
            dtlPageIndex: 1,
            dtlPageSize: 10,
            dtlPageTotal: 0,
            DtltableData: [],
            perData: '',
            MetalPricingPlanId: '',
            MetalPricingPlanNo: '',
            MetalPricingPlanName: '',
            systemSet: JSON.parse(localStorage.getItem('systemSet'))
        };
    },
    computed: {
        // 计算对话框标题
        dialogTitle() {
            return this.isAdd ? '新增' : '编辑';
        }
    },
    mounted() {
        // 组件挂载时加载数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    activated() {
        // keep-alive 缓存组件激活时刷新数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    methods: {
        // 获取类型标签的颜色类型
        getCheckTagType(check) {
            switch (check) {
                case 1:
                    return 'primary';   // 已审核 - 蓝色
                case 0:
                    return 'warning';   // 未审核 - 橙色
                default:
                    return 'info';     // 其他 - 灰色
            }
        },
        // 获取类型名称
        getCheckName(check) {
            switch (check) {
                case 1:
                    return this.$t('common.audited');
                case 0:
                    return this.$t('common.notAudited');
                default:
                    return '';
            }
        },
        getPull() {
            apiMetalPricingPlanPull().then(res => {
                if (res.code == 2000) {
                    this.pullData = res.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },

        // 审核操作----------------------------------------------------------------------------------------------------
        handleCheck(row, check) {
            let data = {
                id: row.id,
                check: check
            };
            apiCheckMetalPricingPlanData(data).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg); // 成功提示
                    this.getData(); // 刷新表格数据
                } else {
                    this.$message.error(res.data.info);// 失败提示
                }
            });
        },
        // 新增编辑操作----------------------------------------------------------------------------------------------------
        // 新增按钮点击事件
        handleAdd() {
            this.isAdd = true;
            this.dialogVisible = true;
            this.addEditForm = {};

            this.$nextTick(() => {
                if (this.pullData.store) {
                    const defaultStore = this.pullData.store.find((store) => store.isdefault == 1);
                    this.$set(this.addEditForm, 'store_no', defaultStore ? defaultStore.store_no : '');
                }
            });
        },

        // 编辑按钮点击事件
        handleEdit(row) {
            this.isAdd = false;
            this.dialogVisible = true;
            // 创建 row 的深拷贝，避免直接引用原始数据
            this.addEditForm = JSON.parse(JSON.stringify(row));
        },

        // 保存数据（新增或编辑）
        saveData() {
            if (this.isAdd) {
                // 新增操作
                apiAddMetalPricingPlanData(this.addEditForm).then(res => {
                    if (res.code == 2000) {
                        this.$message({ message: '添加成功', type: 'success' });
                        this.dialogVisible = false;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else {
                // 编辑操作
                apiUpdateMetalPricingPlanData(this.addEditForm).then((res) => {
                    if (res.code === 2000) {
                        this.$message.success(res.msg); // 成功提示
                        this.getData(); // 刷新表格数据
                        this.handleClose(); // 关闭对话框
                    } else {
                        this.$message.error(res.data.info);// 失败提示
                    }
                });
            }
        },

        // 关闭对话框
        handleClose() {
            this.addEditForm = {};// 清空表单数据
            this.dialogVisible = false; // 隐藏对话框
        },

        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let data = {
                        metalpricingplan_no: row.metalpricingplan_no // 金料定价方案编号
                    };
                    apiDeleteMetalPricingPlanData(data).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                });
        },

        // 锁定状态切换事件
        tableDatastates(row) {
            let data = {
                metalpricingplan_no: row.metalpricingplan_no, // 金料定价方案编号
                store_no: row.store_no, // 门店编号
                islock: row.islock, // 锁定状态（1=锁定，0=解锁）
                status: row.status, // 启用状态（1=启用，0=停用）
                isdefault: row.isdefault // 默认状态（1=是，0=否）
            };
            apiUpdateMetalPricingPlanStatus(data).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg);// 成功提示
                } else {
                    this.$message.error(res.data.info); // 失败提示
                }
                this.getData(); // 刷新表格数据
            });
        },
        // 获取列表信息
        getData() {
            this.$load.show(); // 显示加载动画
            apiGetMetalPricingPlanStatusList({
                page: this.pageIndex, // 当前页码
                page_size: this.pageSize, // 每页数量
                seek: this.name// 搜索关键字
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;// 赋值表格数据
                    this.pageTotal = res.data.count;// 赋值总数据量
                } else {
                    this.$message.error(res.data.info);// 错误提示
                }
            });
            this.$load.close(); // 关闭加载动画
        },

        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val; // 更新当前页码
            this.getData();// 重新加载数据
        },
        pageSizeChange(val) {
            this.pageSize = val; // 更新每页数量
            this.getData(); // 重新加载数据
        },



        // ============================================================================
        // ===================================方案内容===================================
        // ============================================================================

        // 方案内容点击事件
        showDtl(row) {
            this.DtlTableVisible = !this.DtlTableVisible;
            this.MetalPricingPlanId = row.id;
            this.MetalPricingPlanNo = row.metalpricingplan_no;
            this.MetalPricingPlanName = row.metalpricingplan_name;
            this.getDtlData(); // 刷新明细表格数据
        },
        closeDtl(row) {
            this.DtlTableVisible = !this.DtlTableVisible;
            this.MetalPricingPlanId = '';
            this.MetalPricingPlanNo = '';
            this.MetalPricingPlanName = '';
            this.getData(); // 刷新主表格数据
        },
        // 明细新增编辑操作
        handleDtlAdd() {
            this.isAdd = true;
            this.dialogDtlVisible = true;
            this.addEditDtlForm = {};
        },

        // 编辑按钮点击事件
        handleDtlEdit(row) {
            this.isAdd = false;
            this.dialogDtlVisible = true;
            // 创建 row 的深拷贝，避免直接引用原始数据
            this.addEditDtlForm = JSON.parse(JSON.stringify(row));
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDtlDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let data = {
                        id: row.id
                    };
                    apiDeleteDtlMetalPricingPlanData(data).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getDtlData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                });
        },
        // 保存数据（新增或编辑）
        saveDtlData() {
            const requestData = {
                ...this.addEditDtlForm,
                metalpricingplan_id: this.MetalPricingPlanId  // 添加 MetalPricingPlanId 参数
            };
            if (this.isAdd) {
                // 新增操作
                apiAddDtlMetalPricingPlanData(requestData).then(res => {
                    if (res.code == 2000) {
                        this.$message({ message: '添加成功', type: 'success' });
                        this.dialogDtlVisible = false;
                        this.getDtlData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            } else {
                // 编辑操作
                apiUpdateDtlMetalPricingPlanData(requestData).then((res) => {
                    if (res.code === 2000) {
                        this.$message.success(res.msg); // 成功提示
                        this.getDtlData(); // 刷新表格数据
                        this.handleDtlClose(); // 关闭对话框
                    } else {
                        this.$message.error(res.data.info);// 失败提示
                    }
                });
            }
        },
        handleDtlClose() {
            this.addEditDtlForm = {};// 清空表单数据
            this.dialogDtlVisible = false; // 隐藏对话框
        },
        // 获取明细信息
        getDtlData() {
            this.$load.show(); // 显示加载动画
            apiGetMetalPricingPlanDtlDate({
                page: this.dtlPageIndex, // 当前页码
                page_size: this.dtlPageSize, // 每页数量
                metalpricingplan_id: this.MetalPricingPlanId
            }).then((res) => {
                if (res.code == 2000) {
                    this.DtltableData = res.data.data;// 赋值表格数据
                    this.dtlPageTotal = res.data.count;// 赋值总数据量
                } else {
                    this.$message.error(res.data.info);// 错误提示
                }
            });
            this.$load.close(); // 关闭加载动画
        },

        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '175' // 权限ID（需根据实际ID调整）
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;// 赋值权限数据
                } else {
                    this.$message.error(res.msg); // 错误提示
                }
            });
        },
        handleDtlPageChange(val) {
            this.dtlPageIndex = val; // 更新当前页码
            this.getDtlData();// 重新加载数据
        },
        pageDtlSizeChange(val) {
            this.dtlPageSize = val; // 更新每页数量
            this.getDtlData(); // 重新加载数据
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}

.el-table th {
    background: #ecf5ff !important;
}

.el-dialog {
    width: 40%;
}

@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }

    .el-message-box {
        width: 100%;
    }

    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
